var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProgramacionesSecuenciales',{attrs:{"grupos":_vm.grupos,"variadores":_vm.variadores,"electrovalvulas":_vm.electrovalvulas,"sensores":_vm.sensores},on:{"reset-groups":_vm.resetGroups,"reset-sensores":_vm.resetSensors}})
}
var staticRenderFns = []

export { render, staticRenderFns }